import React from 'react'
import PriceListsTable from '../../modules/PriceList/components/PriceListsTable'

export default function PricelistPage() {
  return <PriceListsTable />
}
